import axios from 'axios'
import { Message, MessageBox } from "element-ui";
import router from '../router'

const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // 开发环境为空走代理，生产环境为线上地址
    timeout: 15000 // 适当延长超时时间
})

// 请求拦截器
request.interceptors.request.use(config => {
    // 判断是否为外部URL（如阿里云OSS），外部请求不添加认证头，避免触发 OPTIONS 预检导致 403
    const isExternalUrl = config.url && (config.url.startsWith('http://') || config.url.startsWith('https://'));

    if (!isExternalUrl) {
        // 只有自家API请求才设置这些头
        config.headers['Content-Type'] = 'application/json;charset=utf-8';

        try {
            const userStr = localStorage.getItem("user");
            if (userStr) {
                const user = JSON.parse(userStr);
                if (user?.token) {
                    config.headers['token'] = user.token;
                    config.headers['Authorization'] = `Bearer ${user.token}`;
                }
            }
        } catch (e) {
            console.error('解析用户信息失败:', e);
        }
    }

    return config;
}, error => {
    return Promise.reject(error);
});

// 响应拦截器
request.interceptors.response.use(
    response => {
        // 处理文件下载
        if (response.config.responseType === 'blob') {
            return response.data;
        }

        // 安全处理响应数据
        let res = response.data;

        // 处理字符串响应
        if (typeof res === 'string') {
            try {
                res = res ? JSON.parse(res) : null;
            } catch (e) {
                console.error('JSON解析失败:', e);
                return {
                    code: '500',
                    msg: '响应数据格式错误',
                    data: null
                };
            }
        }

        // 处理未定义响应
        if (res === undefined || res === null) {
            return {
                code: '500',
                msg: '空响应数据',
                data: null
            };
        }

        // 处理token失效
        if (res.code === '402') {
            MessageBox.confirm(
                res.msg || '登录状态已过期，请重新登录',
                '系统提示',
                {
                    confirmButtonText: '重新登录',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                localStorage.removeItem('user');
                router.push('/login');
            });

            return Promise.reject(new Error(res.msg || 'Token失效'));
        }

        return res;
    },
    error => {
        // 统一错误处理
        let errorMessage = '请求错误';

        if (error.response) {
            switch (error.response.status) {
                case 400:
                    errorMessage = '请求参数错误';
                    break;
                case 401:
                    errorMessage = '未授权，请登录';
                    router.push('/login');
                    break;
                case 403:
                    errorMessage = '拒绝访问';
                    break;
                case 404:
                    errorMessage = `请求地址出错: ${error.response.config.url}`;
                    break;
                case 408:
                    errorMessage = '请求超时';
                    break;
                case 500:
                    errorMessage = '服务器内部错误';
                    break;
                case 501:
                    errorMessage = '服务未实现';
                    break;
                case 502:
                    errorMessage = '网关错误';
                    break;
                case 503:
                    errorMessage = '服务不可用';
                    break;
                case 504:
                    errorMessage = '网关超时';
                    break;
                default:
                    errorMessage = `未知错误: ${error.response.status}`;
            }
        } else if (error.message.includes('timeout')) {
            errorMessage = '请求超时，请检查网络连接';
        } else if (error.message.includes('Network Error')) {
            errorMessage = '网络错误，请检查网络连接';
        }

        Message.error(errorMessage);
        return Promise.reject(error);
    }
);

export default request;
